import type {LessonPlanningData} from '../types/teacherAllocationAi'

export function cloneLessonPlanningData(data: LessonPlanningData): LessonPlanningData {
  return structuredClone(data)
}
